// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplatesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateFilter>;
}>;


export type ItemTemplatesQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', displayName: string, version: string, isVersioned: boolean, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], stage: Types.Stage, status: Types.ItemTemplateStatus, description?: string | null | undefined, id: string, name: string, statusDetail: { __typename?: 'ItemTemplateStatusDetail', name: string, code: Types.ItemTemplateStatus }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined }> };

export type SaveItemTemplateMutationVariables = Types.Exact<{
  input: Types.SaveItemTemplateInput;
}>;


export type SaveItemTemplateMutation = { __typename?: 'Mutation', saveItemTemplate: { __typename?: 'SaveItemTemplateResult', itemTemplate: { __typename?: 'ItemTemplate', displayName: string, version: string, isVersioned: boolean, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], stage: Types.Stage, status: Types.ItemTemplateStatus, description?: string | null | undefined, id: string, name: string, statusDetail: { __typename?: 'ItemTemplateStatusDetail', name: string, code: Types.ItemTemplateStatus }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined } } };

export type ItemTemplatesDevelopmentsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.DevelopmentFilter>;
}>;


export type ItemTemplatesDevelopmentsQuery = { __typename?: 'Query', developments: Array<{ __typename?: 'Development', id: string, name: string }> };

export type SettingsItemTemplateFragment = { __typename?: 'ItemTemplate', displayName: string, version: string, isVersioned: boolean, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], stage: Types.Stage, status: Types.ItemTemplateStatus, description?: string | null | undefined, id: string, name: string, statusDetail: { __typename?: 'ItemTemplateStatusDetail', name: string, code: Types.ItemTemplateStatus }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined };

export const SettingsItemTemplateFragmentDoc = gql`
    fragment SettingsItemTemplate on ItemTemplate {
  ...Named
  displayName
  version
  isVersioned
  createdAt
  updatedAt
  stage
  status
  statusDetail {
    name
    code
  }
  description
  development {
    ...Named
  }
  readyPlan {
    id
  }
}
    ${NamedFragmentDoc}`;
export const ItemTemplatesDocument = gql`
    query ItemTemplates($filter: ItemTemplateFilter) {
  itemTemplates(filter: $filter) {
    ...SettingsItemTemplate
  }
}
    ${SettingsItemTemplateFragmentDoc}`;

/**
 * __useItemTemplatesQuery__
 *
 * To run a query within a React component, call `useItemTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useItemTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplatesQuery, ItemTemplatesQueryVariables>(ItemTemplatesDocument, options);
      }
export function useItemTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplatesQuery, ItemTemplatesQueryVariables>(ItemTemplatesDocument, options);
        }
// @ts-ignore
export function useItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplatesQuery, ItemTemplatesQueryVariables>;
export function useItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplatesQuery | undefined, ItemTemplatesQueryVariables>;
export function useItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplatesQuery, ItemTemplatesQueryVariables>(ItemTemplatesDocument, options);
        }
export type ItemTemplatesQueryHookResult = ReturnType<typeof useItemTemplatesQuery>;
export type ItemTemplatesLazyQueryHookResult = ReturnType<typeof useItemTemplatesLazyQuery>;
export type ItemTemplatesSuspenseQueryHookResult = ReturnType<typeof useItemTemplatesSuspenseQuery>;
export type ItemTemplatesQueryResult = Apollo.QueryResult<ItemTemplatesQuery, ItemTemplatesQueryVariables>;
export const SaveItemTemplateDocument = gql`
    mutation SaveItemTemplate($input: SaveItemTemplateInput!) {
  saveItemTemplate(input: $input) {
    itemTemplate {
      ...SettingsItemTemplate
    }
  }
}
    ${SettingsItemTemplateFragmentDoc}`;
export type SaveItemTemplateMutationFn = Apollo.MutationFunction<SaveItemTemplateMutation, SaveItemTemplateMutationVariables>;

/**
 * __useSaveItemTemplateMutation__
 *
 * To run a mutation, you first call `useSaveItemTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveItemTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveItemTemplateMutation, { data, loading, error }] = useSaveItemTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveItemTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveItemTemplateMutation, SaveItemTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveItemTemplateMutation, SaveItemTemplateMutationVariables>(SaveItemTemplateDocument, options);
      }
export type SaveItemTemplateMutationHookResult = ReturnType<typeof useSaveItemTemplateMutation>;
export type SaveItemTemplateMutationResult = Apollo.MutationResult<SaveItemTemplateMutation>;
export type SaveItemTemplateMutationOptions = Apollo.BaseMutationOptions<SaveItemTemplateMutation, SaveItemTemplateMutationVariables>;
export const ItemTemplatesDevelopmentsDocument = gql`
    query ItemTemplatesDevelopments($filter: DevelopmentFilter) {
  developments(filter: $filter) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useItemTemplatesDevelopmentsQuery__
 *
 * To run a query within a React component, call `useItemTemplatesDevelopmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplatesDevelopmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplatesDevelopmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useItemTemplatesDevelopmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>(ItemTemplatesDevelopmentsDocument, options);
      }
export function useItemTemplatesDevelopmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>(ItemTemplatesDevelopmentsDocument, options);
        }
// @ts-ignore
export function useItemTemplatesDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>;
export function useItemTemplatesDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplatesDevelopmentsQuery | undefined, ItemTemplatesDevelopmentsQueryVariables>;
export function useItemTemplatesDevelopmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>(ItemTemplatesDevelopmentsDocument, options);
        }
export type ItemTemplatesDevelopmentsQueryHookResult = ReturnType<typeof useItemTemplatesDevelopmentsQuery>;
export type ItemTemplatesDevelopmentsLazyQueryHookResult = ReturnType<typeof useItemTemplatesDevelopmentsLazyQuery>;
export type ItemTemplatesDevelopmentsSuspenseQueryHookResult = ReturnType<typeof useItemTemplatesDevelopmentsSuspenseQuery>;
export type ItemTemplatesDevelopmentsQueryResult = Apollo.QueryResult<ItemTemplatesDevelopmentsQuery, ItemTemplatesDevelopmentsQueryVariables>;